module.exports = __webpack_public_path__ + "components/country-flag/static/tl-d9027909633807b6605a03fb134b8b39.svg";